import { ReplaySubject } from 'rxjs/ReplaySubject';
import FixtureApi from "../../fixtures/dataManagers/FixtureApi";
import { ACTION_TYPE } from "../Actions";
import Dispatcher from "../Dispatcher";
import { ERRORS } from '../Errors';
import { FixtureDetailed } from "../model/FixtureDetailed";
import { LiveEvents } from '../model/LiveEvents';
import LiveDataApi from './LiveDataApi';
import { WebSocketApi } from './WebSocketApi';

class FixtureDetailedDataManager {
  public async getFixture(id: (number)): Promise<void> {
    try {
      const response = await FixtureApi.getFixture(id) as FixtureDetailed;
      Dispatcher.dispatch({
        type: ACTION_TYPE.FIXTURE_LOADED,
        fixture: response,
      });
    } catch (error) {
      Dispatcher.dispatch({
        type: ACTION_TYPE.FIXTURE_ERROR,
        id: id,
        error,
      });
    }
  }

  public async getHistoricLiveData(id: number, legacy: boolean): Promise<void> {
    try {
      const response: LiveEvents.HistoricLiveEvents = await LiveDataApi.getHistoricLiveData(id, legacy);
      if(!response.events.some(event => event.type === "fixture_ended")) {
        Dispatcher.dispatch({
          type: ACTION_TYPE.HISTORIC_DATA_ERROR,
          id: id,
          error: new Error(ERRORS.HISTORIC_LIVE_FIXTURE_EMPTY_DATA),
        });
        return;
      }

      const subject: ReplaySubject<LiveEvents.Event> = new ReplaySubject<LiveEvents.Event>(Infinity);
      response.events.forEach((event) => {
        subject.next(event)
        if (event.type === "fixture_ended") {
          subject.complete();
        }
      });

      Dispatcher.dispatch({
        type: ACTION_TYPE.HISTORIC_DATA_LOADED,
        id: id,
        liveData: subject,
      });
    } catch (error) {
      Dispatcher.dispatch({
        type: ACTION_TYPE.HISTORIC_DATA_ERROR,
        id: id,
        error,
      });
    }
  }

  public async getLiveData(id: number, legacy: boolean): Promise<void> {
    try {
      const socket: WebSocketApi = LiveDataApi.getLiveDataSocket(id, legacy);
      const subject: ReplaySubject<LiveEvents.Event> = await socket.getLiveData();
      Dispatcher.dispatch({
        type: ACTION_TYPE.LIVE_DATA_LOADED,
        id: id,
        liveData: subject,
        socket: socket
      });
    } catch (error) {
      Dispatcher.dispatch({
        type: ACTION_TYPE.LIVE_DATA_ERROR,
        id: id,
        error,
      });
    }
  }
}

export default new FixtureDetailedDataManager();
